import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { ROBOTO_FONT_BASE64 } from "./roboto-font";
import { SUMMIT_LOGO_BASE64, SUMMIT_LOGO_WIDTH, SUMMIT_LOGO_HEIGHT } from "./summit-logo-b64";
import { TEAMPOWER_LOGO_BASE64, TEAMPOWER_LOGO_WIDTH, TEAMPOWER_LOGO_HEIGHT } from "./teampower-logo-b64";

// Magenta brand color
const BRAND_COLOR = [236, 72, 153];
const FONT_NAME = "LiberationSans";

/**
 * Creates a new jsPDF doc with LiberationSans font loaded (supports Greek characters).
 * Registers both normal AND bold variants so autoTable headers work correctly.
 */
export function createPDF(options = {}) {
  const doc = new jsPDF(options);

  // Register as both normal and bold (same file — avoids fallback to default font)
  doc.addFileToVFS("LiberationSans-Regular.ttf", ROBOTO_FONT_BASE64);
  doc.addFont("LiberationSans-Regular.ttf", FONT_NAME, "normal");
  doc.addFont("LiberationSans-Regular.ttf", FONT_NAME, "bold");
  doc.setFont(FONT_NAME, "normal");

  return doc;
}

/**
 * Adds the TeamPower logo at the top of the page.
 * Returns the Y position after the logo for content to start.
 */
export function addHeader(doc) {
  try {
    const logoW = 45;
    const logoH = logoW * (TEAMPOWER_LOGO_HEIGHT / TEAMPOWER_LOGO_WIDTH);
    doc.addImage(TEAMPOWER_LOGO_BASE64, "PNG", 105 - logoW / 2, 8, logoW, logoH);
    return 8 + logoH + 4;
  } catch (e) {
    return 12;
  }
}

/**
 * Branded autoTable call – applies magenta header styling.
 * Forces LiberationSans on every cell via didParseCell hook.
 */
export function brandedAutoTable(doc, tableOptions) {
  autoTable(doc, {
    ...tableOptions,
    headStyles: {
      fillColor: BRAND_COLOR,
      textColor: [255, 255, 255],
      ...(tableOptions.headStyles || {}),
    },
    styles: {
      font: FONT_NAME,
      ...(tableOptions.styles || {}),
    },
    didParseCell: (data) => {
      data.cell.styles.font = FONT_NAME;
      if (tableOptions.didParseCell) tableOptions.didParseCell(data);
    },
  });
}

/**
 * Adds a standard footer line to the PDF.
 */
export function addFooter(doc, text = "Powered by Bitou & Summit | Members of International Team Experience Network") {
  doc.setFont(FONT_NAME, "normal");
  doc.setFontSize(8);
  doc.setTextColor(150, 150, 150);
  // Summit logo (centered, discreet)
  try {
    const logoW = 20;
    const logoH = logoW * (SUMMIT_LOGO_HEIGHT / SUMMIT_LOGO_WIDTH);
    doc.addImage(SUMMIT_LOGO_BASE64, "PNG", 105 - logoW / 2, 270, logoW, logoH);
  } catch (e) { /* silently skip if image fails */ }
  doc.text(text, 105, 283, { align: "center" });
}

export { BRAND_COLOR };
